import React from "react";
import visitImage from '../../images/handshake-icon.png';
import packImage from '../../images/box-icon.png';
import { Person } from "../../domain/Person";

interface Props {
    changeStepClick: (stepName: string) => void;
    notifyAction: (person?: Person) => void;
}

const NotPlanned: React.FC<Props> = ({ changeStepClick, notifyAction }) => {
    return (
        <>
            <h1>Jeg kommer uanmeldt...</h1>
            <div className='not-planned-options'>
                <div className='option' onClick={() => {
                    notifyAction();
                    changeStepClick("documents");
                }}>
                    <img src={visitImage} alt='visit' />
                    <div className='button pink'>Jeg skal på besøg</div>
                </div>
                <div className='option' onClick={() => {
                    notifyAction();
                    changeStepClick("complete");
                }}>
                    <img src={packImage} alt='package' />
                    <div className='button pink'>Post/Pakker</div>
                </div>
            </div>
        </>
    );
};

export default NotPlanned;